import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from '../../../../components/ui/Select';
import { CompanyView } from '../../../../models/general';

interface CompanySelectorProps {
  companies: CompanyView[];
  selectedCompany: CompanyView | null;
  loading: boolean;
  onChange: (company: CompanyView | null) => void;
}

export default function CompanySelector({
  companies,
  selectedCompany,
  loading,
  onChange,
}: CompanySelectorProps) {
  const { t } = useTranslation();

  const options = companies.map((c) => ({ value: String(c.id), label: c.name }));

  return (
    <div className="rounded-lg border border-border bg-card">
      <div className="border-b border-border px-6 py-4">
        <h3 className="text-lg font-semibold text-foreground">{t('Select Company')}</h3>
      </div>
      <div className="p-6">
        <Select
          label={t('Company')}
          placeholder={t('Select a company to migrate')}
          options={options}
          value={selectedCompany ? String(selectedCompany.id) : ''}
          onChange={(val: string) => {
            const company = companies.find((c) => String(c.id) === val) ?? null;
            onChange(company);
          }}
          searchable
          loading={loading}
        />
      </div>
    </div>
  );
}
